import { QUERIES_KEYS } from "queries";
import { useQuery } from "@tanstack/react-query";
import { coursegroupsApi } from "./coursegroupsApi";

export const useCourseGroupWaitlist = (courseGroupId: string | undefined) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_GROUP_WAITLIST(Number(courseGroupId)),
    queryFn: () => coursegroupsApi.getWaitlist(Number(courseGroupId)),
    enabled: !!courseGroupId,
  });

  return { isLoading, entries: data?.data ?? [] };
};
